<template>
  <v-menu
    open-on-hover
    bottom
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="text-uppercase pr-0"
        small
        plain
        v-bind="attrs"
        v-on="on">
        <img class="mr-1" :src="require('./../assets/' + $i18n.locale + '.gif')"/>
        {{ $i18n.locale }}
      </v-btn>
    </template>
    <v-list
      flat
      tile
      outlined
      dense>
      <v-list-item
        class="text-uppercase"
        dense
        v-for="(lang, i) in langs"
        :key="`lang-${i}`"
        @click="updateLang(lang)">
        <v-list-item-title>
          <img class="mr-1" :src="require('./../assets/' + lang + '.gif')"/>
          <b>{{ lang }}</b>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'SwitchLocale',
    data() {
      return {
        langs: ['en', 'id'],
      };
    },
    methods: {
      updateLang(lang) {
        this.$i18n.locale = lang;
        this.$i18n.setLocaleMessage(lang, require(`./../assets/lang/${lang}.json`));
        localStorage.setItem('lang', lang);
      },
    },
  };
</script>

<style>
</style>